import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, FlexRow } from "@similarweb/ui-components";

export const MoreUsersIconBackground = styled(FlexRow)`
    height: 240px;
    width: 100%;
    border-radius: 8px;
    background: radial-gradient(218.38% 129.07% at 100% 97.98%, #3e74fe 0%, #efefff 100%);
    align-items: center;
    justify-content: center;
`;

export const MoreUsersIcon = styled.img`
    width: 180px;
    height: 180px;
`;

export const Title = styled.h2`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])};
    margin: 0;
    font-weight: 700;
    padding-top: 30px;
`;

export const Description = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[500])};
    line-height: 24px;
    padding-top: 16px;
    text-align: center;
`;

export const CTAButton = styled(Button)`
    color: ${colorsPalettes.blue[500]};
    margin-top: 30px;
    margin-bottom: 8px;
`;
